/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePendingMessageFilterOptions } from '../../models/api-response-pending-message-filter-options';

export interface GetPendingMessageFilterOptions$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
}

export function getPendingMessageFilterOptions(http: HttpClient, rootUrl: string, params: GetPendingMessageFilterOptions$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePendingMessageFilterOptions>> {
  const rb = new RequestBuilder(rootUrl, getPendingMessageFilterOptions.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePendingMessageFilterOptions>;
    })
  );
}

getPendingMessageFilterOptions.PATH = '/v1/api/pending-messages/filter-options';
